import styled from 'styled-components';

export const MiniButtonStyled = styled.button<{
  editing: boolean;
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  column-gap: 12px;
  padding: 3px 6px;
  border-radius: 4px;
  height: 16.5px;
  background-color: ${(props) =>
    props.editing
      ? props.disabled
        ? props.theme.atlas.semantic.color.ui.loading.default
        : props.theme.atlas.semantic.color.action.primary.default
      : props.disabled
        ? props.theme.atlas.semantic.color.surface.subtle
        : props.theme.atlas.semantic.color.outline.default};
  color: ${(props) =>
    props.editing
      ? props.theme.atlas.semantic.color.action.primary.onPrimary
      : props.theme.atlas.semantic.color.type.default};
  border: none;
  font-size: 9px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 9px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.27px;
  text-transform: uppercase;
  cursor: pointer;
  &:hover {
    ${(props) =>
      !props.disabled &&
      `background-color: ${
        props.editing
          ? props.theme.atlas.semantic.color.action.primary.hover
          : props.theme.atlas.semantic.color.outline.hover
      };`}
  }
`;
